import PlatinumVenueShift from './PlatinumVenueShift';

export default PlatinumVenueShift;
